import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { LogType, logTypes } from "@planzone/dto";

import { SelectList } from "@common/selectList";
import { Checkbox } from "@common/filterMenu/checkbox";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { usePreferences } from "@components/preferences";
import { Props } from "./types";
import styles from "./styles.scss";

function ToolBar({ filter, setFilter }: Props) {
  const { state, edit } = usePreferences();
  const { t } = useTranslation();

  const toggleLogType = (log: LogType) =>
    setFilter({
      logType: !filter.logType
        ? [log]
        : filter.logType.includes(log)
          ? filter.logType.filter((l) => l !== log)
          : [...filter.logType, log],
    });

  const hasSelection = filter.logType && filter.logType.length > 0;

  return (
    <div className={styles.toolBar}>
      <p className={styles.title}>{t("planzoneLogsPage.filter.title")}</p>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, show, hide }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.opened]: isOpen })}
              onClick={isOpen ? hide : show}
            >
              {hasSelection ? (
                <p className={styles.selection}>
                  {filter.logType
                    .map((log) => t(`planzoneLogsPage.filter.selection.${log}`))
                    .join(", ")}
                </p>
              ) : (
                <p className={styles.placeholder}>
                  {t("planzoneLogsPage.filter.placeholder")}
                </p>
              )}
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {logTypes.map((log, key) => (
                <div
                  key={key}
                  className={styles.item}
                  onClick={() => toggleLogType(log)}
                >
                  <Checkbox
                    isChecked={
                      !!(filter.logType && filter.logType.includes(log))
                    }
                    check={() => {}}
                  />
                  <p className={styles.label}>
                    {t(`planzoneLogsPage.filter.selection.${log}`)}
                  </p>
                </div>
              ))}
              {hasSelection && (
                <div
                  className={styles.clearButton}
                  onClick={() => setFilter({ logType: [] })}
                >
                  <p>{t("planzoneLogsPage.filter.clear")}</p>
                </div>
              )}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ToolBar };
